// Endpoints
import { typesEndpoint } from '../../../common/types';

// Utils
import { getApiRequest } from '../../../utils';

export const apiGetSeguros = async () => {
  return getApiRequest({
    url: typesEndpoint.getSeguros,
  });
};

export const apiGetCatalogo = async params => {
  return getApiRequest({
    url: typesEndpoint.getCatalogo,
    params: {
      id_plan_seguro: params.idPlan,
    },
  });
};
